/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';

type Props = {
  count: number,
  onCancel: () => void,
};

const PendingUploads = ({ count, onCancel }: Props) => {
  if (count > 0) {
    return (
      <div>
        <Message
          attached
          icon="hourglass start"
          content={`Actuellement ${count} envoi(s) en attente`}
        />
        <div
          className="ui bottom attached red tiny icon button"
          onClick={onCancel}
        >
          <i className="close icon" />
          Annuler les envois
        </div>
      </div>
    );
  }

  return null;
};

export default PendingUploads;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Upload/components/PendingUploads.js